/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForLogAnalyticsWorkspacesAzure extends models.GovernanceConfigurationBaseForOperations {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForLogAnalyticsWorkspacesAzure");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForLogAnalyticsWorkspacesAzure.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForLogAnalyticsWorkspacesAzure>): GovernanceConfigurationForLogAnalyticsWorkspacesAzure {
        let obj = Object.assign(new GovernanceConfigurationForLogAnalyticsWorkspacesAzure(), model);
        GovernanceConfigurationForLogAnalyticsWorkspacesAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForLogAnalyticsWorkspacesAzure>): GovernanceConfigurationForLogAnalyticsWorkspacesAzure {
        if (!model) return null;
        return GovernanceConfigurationForLogAnalyticsWorkspacesAzure.newInstance(<GovernanceConfigurationForLogAnalyticsWorkspacesAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForLogAnalyticsWorkspacesAzure) {
        if (!obj) return;

        models.GovernanceConfigurationForLogAnalyticsWorkspacesAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForLogAnalyticsWorkspacesAzure): boolean {
        if (models.GovernanceConfigurationBaseForOperations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForLogAnalyticsWorkspacesAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Workspaces Id
     */
    workspace_id: string;

    /**
     * Workspaces Name
     */
    workspace_name: string;

}
